<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="title"
    show-close
    width="400px"
    :close-on-click-modal="false"
    :before-close="() => $refs.editForm.cancel()"
    v-el-dialog-drag
  >
    <EditForm
      ref="editForm"
      :listOrderCode="listOrderCode"
      @reload="$emit('reload')"
      @close="close()"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.editForm.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.editForm.save()">
        {{ this.$l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    listOrderCode: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
